<div class="toast-container">
  <ng-container *ngFor="let item of msg.toasts.value$ | async">
    <div [ngClass]="getClass(item)" id="{{ item.id }}">
      <div class="msg">
        <div *ngIf="item.title" class="msg-head">
          <span class="title">{{ item.title }}</span>
        </div>
        <div class="msg-body">
          {{ item.message }}
        </div>
      </div>
      <div (click)="remove(item.id)" class="cross-btn">
        <svg class="cross" fill="currentColor" viewBox="0 0 32 32">
          <path d="M4 8 L8 4 L16 12 L24 4 L28 8 L20 16 L28 24 L24 28 L16 20 L8 28 L4 24 L12 16 z"></path>
        </svg>
      </div>
    </div>
  </ng-container>
</div>
